import React, { Component } from "react";
import { Segment, Header, Grid } from "semantic-ui-react";
import { UserRoles } from "../../utils/Consts";
import { Trans } from "@lingui/macro";
import RecalculateButton from "../recalculations/RecalculateModal";
import RecalculateHistoryButton from "../recalculations/RecalculateHistoryModal";

export default class RecalculateConfig extends Component {
  render() {
    return (
      <Segment basic padded>
        <Header as="h2">
          <Trans>Recálculo de datos</Trans>
        </Header>
        <Grid stackable centered columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Segment padded textAlign="center">
                <Header.Subheader textAlign="center">
                  <Trans>
                    Recalcular los datos correspondientes a todas las órdenes
                  </Trans>
                </Header.Subheader>
                <RecalculateButton />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Segment padded textAlign="center">
                <Header.Subheader textAlign="center">
                  <Trans>
                    Recalcular los datos correspondientes a todos los históricos
                    de las órdenes
                  </Trans>
                </Header.Subheader>
                <RecalculateHistoryButton />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

RecalculateConfig.getMenuItem = () => <Trans>Recálculo de datos</Trans>;
RecalculateConfig.getPermissions = userLevel =>
  userLevel === UserRoles.ADMINISTRATOR;
